// MatchResultForm.jsx
import React, { useState } from "react";
import { api } from "./page";

const MatchResultForm = ({ teams, onMatchAdded }) => {
  const [teamA, setTeamA] = useState("");
  const [teamB, setTeamB] = useState("");
  const [sets, setSets] = useState([
    { pointsA: "", pointsB: "" },
    { pointsA: "", pointsB: "" },
    { pointsA: "", pointsB: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleSetChange = (index, field, value) => {
    const updated = [...sets];
    updated[index][field] = value;
    setSets(updated);
  };

  const isFormValid = () => {
    if (!teamA || !teamB || teamA === teamB) return false;
    return sets.every(s => s.pointsA !== "" && s.pointsB !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) return;

    setLoading(true);
    setMessage({ text: "", type: "" });
    try {
      await api.post("/addMatch", { teamA, teamB, sets });
      setMessage({ text: "Match recorded successfully", type: "success" });
      setTeamA("");
      setTeamB("");
      setSets([
        { pointsA: "", pointsB: "" },
        { pointsA: "", pointsB: "" },
        { pointsA: "", pointsB: "" },
      ]);
      if (onMatchAdded) onMatchAdded();
    } catch (err) {
      setMessage({ text: err.response?.data?.error || "Failed to add match", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "1rem", border: "1px solid #ddd", borderRadius: "6px" }}>
      <h3>Add Match Result</h3>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <select value={teamA} onChange={(e) => setTeamA(e.target.value)}>
            <option value="">Select Team A</option>
            {teams.map(t => <option key={t._id} value={t.name}>{t.name}</option>)}
          </select>
          <select value={teamB} onChange={(e) => setTeamB(e.target.value)}>
            <option value="">Select Team B</option>
            {teams.map(t => <option key={t._id} value={t.name}>{t.name}</option>)}
          </select>
        </div>

        {sets.map((set, idx) => (
          <div key={idx} style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginBottom: "0.5rem" }}>
            <span>Set {idx + 1}</span>
            <input
              type="number"
              placeholder="Points A"
              value={set.pointsA}
              onChange={(e) => handleSetChange(idx, "pointsA", e.target.value)}
            />
            <input
              type="number"
              placeholder="Points B"
              value={set.pointsB}
              onChange={(e) => handleSetChange(idx, "pointsB", e.target.value)}
            />
          </div>
        ))}

        <div style={{ marginTop: "1rem" }}>
          <button
            type="submit"
            disabled={!isFormValid() || loading}
          >
            {loading ? "Saving..." : "Save Match"}
          </button>
        </div>

        {message.text && (
          <p style={{ color: message.type === "error" ? "red" : "green" }}>{message.text}</p>
        )}
      </form>
    </div>
  );
};

export default MatchResultForm;
